<template>
  <div class="cell-content">
    <div class="flex-content">
      <h3>门禁权限范围</h3>
    </div>
    <div class="flex-box">
      <div class="tab-content">
        <div
            v-for="(tab, index) in accessList"
            v-bind:key="tab.id"
            v-bind:class="['tab-button', { active: currentIndex === index }]"
            v-on:click="tabChange(index)"
        >
          {{ tab.title }}
        </div>
      </div>
    </div>
    <div v-if="boxList" class="box-content">
      <h4 class="box-title">
        <span>{{boxList.title}} - 员工门禁权限</span>
        <div class="button-content">
          <Button :disabled="copyStatus" @click="handleCopy(boxList)" icon="md-copy">复制本社区</Button>
          <Button v-if="cellStatus.editStatus" :disabled="pasteStatus" icon="md-clipboard" @click="handlePaste">粘贴</Button>
        </div>
      </h4>
      <div class="floor-item-content">
        <div v-for="(floor, num) in boxList.children" :key="num" class="floor-item">
          <div class="floor-name">
            <span class="floor-title">{{floor.title}}</span>
            <span v-if="cellStatus.editStatus">
              <Checkbox v-model="floor.checkedAll" @on-change="handleCheckAll($event, num)"></Checkbox> 全选
            </span>
          </div>
          <div :class="['e-checkbox-group', { editStatus: cellStatus.editStatus }]">
            <div
                v-for="item in floor.children"
                v-bind:key="item.id"
                :class="['e-checkbox', { 'active': item.checked&&!item.pre,'actives': item.checked&&item.pre, }]"
                v-on:click="handleClick(item, num)"
            >
              {{item.title}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { getCheckedList, isEquals } from '@/util/tree.js';
  export default {
    name: 'Cell',
    props: {
      accessList: Array,
      accessIds: Array,
      cellStatus: Object
    },
    data () {
      return {
        currentIndex: 0,
        loading: false,
        pasteStatus: true
      }
    },
    computed: {
      boxList () {
        this.handleCheckedNum(this.accessList);
        return this.accessList[this.currentIndex];
      },
      copyStatus () {
        let arr = [];
        getCheckedList(this.accessList[this.currentIndex].children, arr)
        return !arr.length;
      }
    },
    mounted () {
      let access = JSON.parse(sessionStorage.getItem('access'));
      if (access && access.id) {
        this.pasteStatus = false;
      }
    },
    methods: {
      tabChange (index) {
        this.currentIndex = index;
      },
      handleCheckedNum (boxList) {
        if (boxList.length) {
          boxList[this.currentIndex].children.forEach((item, index, that) => {
            let checkedNum = that[index].children.filter(item => item.checked).map(i => i.id).length;
            that[index].checkedAll = that[index].children.length === checkedNum;
          })
        }
      },
      handleClick (room, num) {
        if (this.cellStatus.editStatus) { // 只有在编辑状态才可以点击
          this.accessList[this.currentIndex].children[num].children.forEach((item) => {
            if (item.id === room.id) {
              item.checked = !room.checked;
            }
          });
          this.handleCheckedNum(this.accessList);
        }
      },
      handleCheckAll (status, num) {
        this.accessList[this.currentIndex].children[num].children.forEach(item => { item.checked = status });
      },
      handleCopy (boxList) { // 复制
        this.$Notice.success({ title: `复制成功！` });
        this.pasteStatus = false;
        sessionStorage.setItem('access', JSON.stringify(boxList));
      },
      handlePaste () { // 粘贴
        let access = JSON.parse(sessionStorage.getItem('access'));
        if (!access) {
          this.$Notice.warning({
            title: `粘贴内容不能为空！`
          });
          return;
        }
        if (access.id === this.boxList.id) {
          this.$set(this.accessList, this.currentIndex, access);
          this.$Notice.success({ title: `粘贴成功！` });
        } else {
          this.$Notice.warning({
            title: `不是同一个社区的权限，不能粘贴哦！`
          });
        }
      },
      handleBack () {
        let deviceIdList = [];
        getCheckedList(this.accessList, deviceIdList);
        let that = this;
        if (!isEquals(deviceIdList, this.accessIds)) {
          that.$Modal.confirm({
            title: '是否保存修改?',
            okText: '保存',
            cancelText: '不保存',
            onOk () {
              that.handleSave();
              this.remove();
            },
            onCancel () {
              that.cellStatus.editStatus = false;
              that.$emit('change');
            },
            loading: true
          })
        } else {
          this.cellStatus.editStatus = false;
        }
      },
      handleSave (callback) { // 保存
        let deviceIdList = [];
        getCheckedList(this.accessList, deviceIdList);
        const userId = this.$route.query.id;
        this.$post(`/customer/perm/${userId}`, { deviceIdList }).then(res => {
          if (res.success) {
            if (typeof callback === 'function') {
              callback();
            }
            this.$Message.success(res.msg);
            this.$emit('change');
            this.cellStatus.editStatus = false;
          }
        })
      },
      handleSaveButton () {
        let that = this;
        that.loading = true;
        this.handleSave(function () {
          that.loading = false
        });
      }
    }
  }
</script>

<style lang="less">
  @import "../../index.less";
  .cell-content{
    .flex-content{
      display: flex;
      justify-content: space-between;
      margin: 10px 0;
      .button-content{
        text-align: end;
        button{
          margin: 0 10px;
        }
      }
    }
    .flex-box{
      display: flex;
      .tab-content{
        overflow-x: scroll;
        white-space: nowrap;
        .tab-button {
          display: inline-block;
          padding: 3px 10px;
          border: 1px solid #2F2F2F;
          cursor: pointer;
          font-size: 14px;
          color:  @active-font-color;
          margin-bottom: 20px;
          &.active{
            background: #2F2F2F;
            color: #ffffff;
            border-color: #2F2F2F;
          }
        }
      }
    }
    .box-content{
      height: 680px;
      overflow: scroll;
      /*padding-right: 15px;*/
      .box-title{
        font-size: 14px;
        line-height: 2;
        margin: 20px 0;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        .button-content{
          button{
            margin-left: 5px;
          }
        }
      }
      .floor-item-content{
        padding-left: 20px;
        .floor-item{
          .floor-name{
            .floor-title{
              font-size: 16px;
              display: inline-block;
              width: 80px;
            }
          }
          .e-checkbox-group{
            display: flex;
            flex-wrap: wrap;
            margin: 20px 0;
            padding-left: 20px;
            .e-checkbox{
              display: inline-block;
              padding: 3px 10px;
              cursor: pointer;
              font-size: 14px;
              margin-right: 20px;
              margin-bottom: 20px;
              border: 1px solid #999999;
              color: #999999;
              border-radius: 50px;
              &.active{
                border: 1px solid #239cd2;
                color: #239cd2;
                border-radius: 50px;
              }
              &.actives{
                border: 1px solid @actives-border-color;
                color: @actives-font-color;
                border-radius: 50px;
              }
            }
            &.editStatus{
              .e-checkbox{
                border: 1px solid @active-color;
                color: @active-color;
                border-radius: 50px;
                &.active{
                  background: @active-color;
                  color: #ffffff;
                  border-color: @active-color;
                }
                &.actives{
                  background: @actives-border-color;
                  color: #ffffff;
                  border-color: @actives-border-color;
                }
              }
            }
          }
        }
      }
    }
    .button-container{
      margin: 40px 0;
      .e-button{
        display: inline-block;
        padding: 3px 10px;
        border: 1px solid @active-color;
        cursor: pointer;
        font-size: 14px;
        width: 88px;
        margin-right: 10px;
        text-align: center;
        color: #ffffff;
        border-radius: 3px;
        font-weight: bolder;
        background-color: @active-color;
      }
    }
  }
</style>
